export enum TrackedEventAction {
    CLICKED = 'Clicked',
    OPENED = 'Opened',
    CLOSED = 'Closed',
    CHANGED = 'Changed',
    SELECTED = 'Selected',
    SEARCHED = 'Searched',
    SEARCH_CANCELED = 'Search Canceled',
    FILTER_OPENED = 'Filter Opened',
    FILTER_APPLIED = 'Filter Applied',
    FILTER_CLEARED = 'Filter Cleared',
    COMPLETED = 'Completed',
    CHECKED = 'Checked',
    UNCHECKED = 'Unchecked'
}
